<template>
  <div>
    <my-notification :icon="'refresh'">
      <template #title>
        {{ $t('compCarbonDocsUpdateEmissionsFactors.title-emfa-update') }}
      </template>
      <p>
        {{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-1')
        }}<strong>{{
          $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-str-1')
        }}</strong
        >{{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-2') }}
        <br />
        {{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-3') }}
        <br />
        <br />
        {{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-4')
        }}<em>{{ $t('compCarbonDocsUpdateEmissionsFactors.g1p5') }}</em
        >{{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-5')
        }}<strong>{{
          $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-str-2')
        }}</strong
        >{{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-6')
        }}<em>{{ $t('compCarbonDocsUpdateEmissionsFactors.g1p5') }}</em
        >.
        <br />
        {{ $t('compCarbonDocsUpdateEmissionsFactors.emfa-update-7') }}
      </p>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'UpdateEmissionsFactors',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
